export const schema = {
  id: 'installation-commissioning-decommissioning',
  name: 'General Installation, Commissioning & Decommissioning Record',
  description: 'Multi-trade equipment handover, commissioning test report, safe isolation & environmental decommissioning disposal record',
  category: 'Plumbing',
  sections: [
    {
      id: 'contractorDetails',
      title: '1. Contractor & Lead Engineer Details',
      fields: [
        { id: 'companyName', label: 'Company / Contractor Name', type: 'text', required: true },
        { id: 'engineerName', label: 'Lead Engineer Name', type: 'text', required: true },
        { id: 'tradeCompetencyNo', label: 'Trade Competency / Scheme Card ID (Gas Safe, F-Gas, NICEIC, OFTEC)', type: 'text', required: true },
        { id: 'telephone', label: 'Telephone Number', type: 'tel', required: true }
      ]
    },
    {
      id: 'siteDetails',
      title: '2. Site Location & Client Details',
      fields: [
        { id: 'clientName', label: 'Client / Asset Owner Name', type: 'text', required: true },
        { id: 'siteAddress', label: 'Site / Premises Address', type: 'textarea', required: true },
        { id: 'postCode', label: 'Postcode', type: 'text', required: true },
        { id: 'workDate', label: 'Date Works Executed', type: 'date', required: true }
      ]
    },
    {
      id: 'scopeOfWorks',
      title: '3. Scope of Mechanical / Electrical Works',
      fields: [
        { id: 'workActivityType', label: 'Primary Activity Type', type: 'select', options: ['New Installation & Commissioning', 'Plant Replacement / Upgrade', 'Safe Decommissioning & Environmental Disposal', 'Temporary Plant Isolation / Mothballing'], required: true },
        { id: 'equipmentCategory', label: 'Equipment Category', type: 'select', options: ['HVAC / Heat Pump / Chiller System', 'Commercial Boiler / Plant Room Heat Generator', 'Unvented Water Storage / Calorifier', 'Air Handling / Extraction Ventilation Unit', 'Gas Fired Process / Commercial Catering Equipment', 'Solar Thermal / Biomass Renewable Plant'], required: true },
        { id: 'equipmentMakeModel', label: 'Equipment Make & Model', type: 'text', required: true },
        { id: 'serialNumber', label: 'Equipment Serial Number / Asset Tag', type: 'text', required: true },
        { id: 'locationInBuilding', label: 'Plant Room / Specific Location in Building', type: 'text', required: true }
      ]
    },
    {
      id: 'safeIsolationAndEnvironment',
      title: '4. Safe Isolation & Environmental Fluid Recovery',
      fields: [
        { id: 'safeIsolationCompleted', label: 'Safe Electrical Isolation Verified (LOTO - Lockout/Tagout)?', type: 'select', options: ['Yes - Verified Proved Dead', 'N/A - Non-electrical'], required: true },
        { id: 'gasOrFuelIsolated', label: 'Fuel / Gas / Oil Supply Isolated & Capped with Purge?', type: 'select', options: ['Yes - Capped & Purged', 'N/A'], required: true },
        { id: 'fGasRecovered', label: 'Refrigerant F-Gas Safely Recovered into Recovery Cylinder?', type: 'select', options: ['Yes - Fully Recovered', 'N/A - No Fluorinated Gases', 'New Pre-Charged System'], required: true },
        { id: 'refrigerantTypeAndWeightKg', label: 'Recovered Refrigerant Type & Weight (kg)', type: 'text' },
        { id: 'wasteTransferCertNumber', label: 'Hazardous Waste Transfer Note / Consignment Note Reference', type: 'text' },
        { id: 'glycolOrFluidDisposalMethod', label: 'System Water / Glycol Fluid Drainage Method', type: 'select', options: ['Captured in Drums for Environmental Recycling', 'Discharged with Water Authority Consent', 'Closed Loop Unopened'], required: true }
      ]
    },
    {
      id: 'commissioningReadings',
      title: '5. Commissioning Test Values & Performance Checks',
      fields: [
        { id: 'operatingPressureBar', label: 'Design System Operating Pressure (Bar)', type: 'number' },
        { id: 'flowTemperatureC', label: 'Design / Commissioned Flow Temperature (°C)', type: 'number' },
        { id: 'electricalVoltageAndAmps', label: 'Supply Voltage (V) & Full Load Current (Amps)', type: 'text' },
        { id: 'safetyInterlocksVerified', label: 'All Safety Relief Valves, Limit Stats & Interlocks Tested?', type: 'select', options: ['Yes - All Operational', 'N/A - Decommissioning'], required: true },
        { id: 'manufacturersChecklistAttached', label: 'Manufacturer Commissioning Logbook Completed & Signed?', type: 'select', options: ['Yes - Benchmark / Warranty Log Stamped', 'N/A'], required: true }
      ]
    },
    {
      id: 'handoverAndSignatures',
      title: '6. Work Completion Handover & Sign-Off',
      fields: [
        { id: 'completionStatus', label: 'Final Completion Status', type: 'select', options: ['COMMISSIONED & LIVE IN OPERATION', 'SAFELY DECOMMISSIONED & REMOVED', 'PARTIALLY COMPLETED - SAFE ISOLATION ACTIVE'], required: true },
        { id: 'engineerComments', label: 'Engineer Summary & Operational Notes', type: 'textarea' },
        { id: 'engineerSignature', label: 'Lead Engineer Signature', type: 'signature', required: true },
        { id: 'clientSignature', label: 'Client / Site Representative Signature', type: 'signature', required: true }
      ]
    }
  ]
};

export default schema;
